import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627
    },
    zoom: 11
  };

const mapStyle = [
   { width:'100%' ,
    height:'450px',
    border:0,
    allowFullScreen:'',
    loading:'lazy',
    referrerPolicy:'no-referrer-when-downgrade'
}
]
class Googlemap extends Component {
    render(){
        return(   
            
            <div className="py-2">
            <Row>
                <Col>
                <div  className="d-none" style={{ height: '150vh', width: '100%' }}>
                <GoogleMapReact 
    bootstrapURLKeys={{ key: "" }}
    defaultCenter={defaultProps.center}
    defaultZoom={defaultProps.zoom}
  >
    <AnyReactComponent
      lat={59.955413}
      lng={30.337844}
      text="My Marker"
    />
  </GoogleMapReact>
  </div>
   
  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15135.546534247565!2d74.0102514!3d18.4887936!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfcb4fe6513e8e65f!2sInnovera%20School%20-%20Loni%20Kalbhor!5e0!3m2!1sen!2sin!4v1663941024490!5m2!1sen!2sin" allowFullScreen=''loading='lazy' referrerPolicy='no-referrer-when-downgrade' style={{ height: '50vh', width: '100%'  }}/>

                </Col>
            </Row>
        </div>  
        )
    }
}

export default Googlemap;